import { useTranslation } from '@portals-platform/i18n';
import {
  FormField,
  FormGrid,
  SelectField,
  useFormContext,
  useWatch,
} from '@portals-platform/ui-forms';
import { useAssuredsByCountry } from '../../../data-access/index.js';
import { useFieldText } from '../../../hooks/use-field-text.js';
import { createEmptyStorageLocation } from '../../../lib/new-certificate/defaults.js';
import { STATIC_FIELD_CONFIG } from '../../../lib/new-certificate/fields.js';
import type { FormValues } from '../../../lib/new-certificate/types.js';
import { CertificateSection } from './certificate-section.js';

interface PolicyDetailsSectionProps {
  hasStorageCoverage: boolean;
}

export function PolicyDetailsSection({ hasStorageCoverage }: PolicyDetailsSectionProps) {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<FormValues>();
  const countryCode = useWatch({ control, name: 'countryCode' });
  const contractingEntityOptions = useAssuredsByCountry()[countryCode] ?? [];
  const contractingEntity = useFieldText(STATIC_FIELD_CONFIG.contractingEntity);
  const currency = useFieldText(STATIC_FIELD_CONFIG.currency);

  const handleEntityChange = () => {
    setValue('storageLocations', hasStorageCoverage ? [createEmptyStorageLocation(1)] : []);
  };

  return (
    <CertificateSection title={t('certificates.new.sections.policyDetails')}>
      <FormGrid>
        <FormField name="contractingEntity" label={contractingEntity.label} required>
          <SelectField
            name="contractingEntity"
            options={contractingEntityOptions}
            placeholder={contractingEntity.placeholder || ''}
            onChange={handleEntityChange}
          />
        </FormField>
        <FormField name="currency" label={currency.label} required>
          <SelectField name="currency" options={STATIC_FIELD_CONFIG.currency.options} />
        </FormField>
      </FormGrid>
    </CertificateSection>
  );
}
